module.exports = __webpack_public_path__ + "assets/img/1606_01.jpg?236df0f08bbb849dc223324b33bf17b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1606_01.jpg
// module id = 1111
// module chunks = 0